import React, { Component } from 'react';
import MainNav from '../navs/MainNav.js';
import TopNav from '../navs/TopNav.js';
import footerPng from '../pages/images/footer.png';
import { Map, Marker } from 'react-amap';
import Footer from '../footer/index.js';

import {
  AboutUsPanel,

} from './index.css';

const wrapperStyles = {
  width: "100%",
  maxWidth: 980,
  margin: "0 auto",
}
const AnyReactComponent = ({ text }) => <div>{text}</div>;

class AboutUs extends Component {
  constructor(props) {
    super(props);
    this.markerEvents = {
      click: (e) => {
        console.log(lang.template("P_YS_PF_YS-LOGIN_0001079584") /* "你点击了这个图标；调用参数为：" */);
        console.log(e);
      }
    }
    this.mapPlugins = ['ToolBar'];
    this.mapCenter = { longitude: 116.234732, latitude: 40.068463 };
    this.markerPosition = { longitude: 116.234732, latitude: 40.068463 };
  }
  componentDidMount() {
    document.getElementById('root').className = '';
    document.getElementsByTagName('body')[0].className = '';
  }

  render() {

    return (
      <div className={AboutUsPanel}>
        {/* <TopNav /> */}
        <MainNav
          btnShow={false}
          loginClick={this.loginClick}
          registryUrl={this.registryUrl}
          activeIndex={'4'}
          history={this.props.history}
          lanCallBack={() => { }}
        />
        <div className="mainCon">
          <div className="title">{lang.template("P_YS_OA_XTTMCENTER_0000035034") /* "联系我们" */}</div>
          <div className="absoutUsCon">
            <div className="lefCon">
              <span className="subtitle">{lang.template("P_YS_SD_SDMB_0000146914") /* "北京总部" */}</span>
              <span className="desc">{lang.template("P_YS_PF_WORKBENCH-FE_0001133310") /* "地址：北京市海淀区北清路68号用友产业园" */}</span>
              <span className="desc">{lang.template("P_YS_PF_WORKBENCH-FE_0001133344") /* "电话：010-62438888" */}</span>
              <span className="desc">{lang.template("P_YS_PF_WORKBENCH-FE_0001133417") /* "邮箱：diwork@yonyou.com" */}</span>

            </div>
            <div className="rightCon">
              <Map amapkey={"4e34b3708df7f3f82680e55b9d178e60"}
                plugins={this.mapPlugins}
                center={this.mapCenter}
                zoom={12}
                events={this.markerEvents}
              >
                <Marker position={this.markerPosition} />
              </Map>
            </div>
          </div>
        </div>
        {/* <div className="mainFooter mainFooterFake">
              <img src={footerPng} alt="" className="footerImg"/>
            </div> */}
        <div className="mainFooter ">
          <Footer />
        </div>
      </div>
    );
  }
}

export default AboutUs;
